import { useStoreValue } from '../../store';
import { useParams } from 'react-router-dom';
import { head, pathOr } from 'ramda';

import BriefText from './components/BriefText';
import BriefAuthor from './components/BriefAuthor';

const Brief = () => {
    const projects = useStoreValue('projects');
    const { projectId } = useParams();
    const project = pathOr({}, [], head(projects.filter(o => o.id === projectId)));

    return (
        <div className="briefWrapper">
            <BriefAuthor project={project} />
            <BriefText project={project} />
        </div>
    );
};

export default Brief;
